import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { LoadingIndicator } from "../../progress/loading-indicator/LoadingIndicator";
import * as Styled from "./Panel.styled";
import { PanelAnimations } from "./PanelAnimations";
import { PanelHeader } from "./PanelHeader";
import { PanelContent } from "./PanelContent";
import { PanelFooter } from "./PanelFooter";
import { PanelSectionSeparator } from "./PanelSectionSeparator";
export const ANIMATION_DIRECTIONS = ["left-to-right", "right-to-left"];
export const PANEL_ANIMATION_DIRECTIONS = {
    LEFT_TO_RIGHT: ANIMATION_DIRECTIONS[0],
    RIGHT_TO_LEFT: ANIMATION_DIRECTIONS[1]
};
export const PANEL_SIZES = {
    small: 400,
    large: 560
};
export const PANEL_VARIANTS = {
    configuration: {
        isElevated: true
    },
    outline: {
        isElevated: false
    },
    summary: {
        isElevated: false
    }
};
export const PanelComponent = forwardRef((props, ref) => {
    /* istanbul ignore next */
    const { animationProps, children, contentRef, hasContentShadow, header, isContentFlex = false, isLoading, flexDirection, footer, size = "small", variant = "configuration", ...otherProps } = props;
    const isAnimated = animationProps && animationProps.direction && animationProps.isOpen !== undefined;
    const panelContent = (_jsxs(Styled.PanelWrapper, { "data-testid": "Panel", ref: ref, panelWidth: PANEL_SIZES[size], variant: variant, ...otherProps, children: [header && _jsx(PanelHeader, { hasContentShadow: hasContentShadow, children: header }), _jsx(PanelContent, { ref: contentRef, isLoading: isLoading, isContentFlex: isContentFlex, flexDirection: flexDirection, children: isLoading ? _jsx(LoadingIndicator, {}) : children }), footer && _jsx(PanelFooter, { hasContentShadow: hasContentShadow, children: footer })] }));
    if (isAnimated) {
        return (_jsx(PanelAnimations, { ...animationProps, variant: variant, size: size, children: panelContent }));
    }
    return panelContent;
});
PanelComponent.displayName = "Panel";
export const Panel = Object.assign(PanelComponent, {
    SectionSeparator: PanelSectionSeparator,
    animationDirections: ANIMATION_DIRECTIONS,
    sizes: PANEL_SIZES
});
Panel.defaultProps = {
    size: "small",
    variant: "configuration"
};
